import { styled } from '@mui/system'

export const Container = styled('div')({
  padding: '20px',
  maxWidth: '800px',
  margin: '0 auto',
})

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
})

export const ScoreBoard = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  gap: '20px',
  padding: '20px',
  backgroundColor: '#f5f5f5',
  borderRadius: '8px',
  marginBottom: '20px',
})

export const PlayLogItem = styled('div')({
  padding: '10px',
  borderBottom: '1px solid #eee',
  '&:last-child': {
    borderBottom: 'none',
  },
})

export const Controls = styled('div')({
  display: 'flex',
  gap: '10px',
  marginBottom: '20px',
})

export const Button = styled('button')({
  padding: '8px 16px',
  borderRadius: '4px',
  border: 'none',
  backgroundColor: '#1976d2',
  color: 'white',
  cursor: 'pointer',
  '&:disabled': {
    backgroundColor: '#ccc',
    cursor: 'not-allowed',
  },
})
